import Api from "./Api";

export default {
  async show(auditId, algorithm) {
    return Api().get("auditOperation/GetAuditAnalysis", {
      params: { auditId, algorithm },
    });
  },
};
